export default class Message {
  constructor (faultMessage) {
    this.message = faultMessage.message
    this.dateTime = faultMessage.dateTime
    this.UserId = faultMessage.UserId
    this.isOwner = faultMessage.isOwner
    this.userName = faultMessage.userName
  }
}
